'use client';

import { TermsOfUsePage } from 'client/modules/terms/pages/terms-of-use/TermsOfUsePage';

export default TermsOfUsePage;
